module.exports = __webpack_public_path__ + "img/cloud-management.23308687.jpg";